/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvestmentAccountTickerGetResponseFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeInvestmentAccountTickerPostRequest, type InvestmentAccountTickerGetResponse, type InvestmentAccountTickerPostRequest, type ProblemDetails } from '../../../models';
// @ts-ignore
import { type WithTickerItemRequestBuilder, WithTickerItemRequestBuilderNavigationMetadata, WithTickerItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /investmentaccounts/{investmentAccountId}/tickers
 */
export interface TickersRequestBuilder extends BaseRequestBuilder<TickersRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.investmentaccounts.item.tickers.item collection
     * @param tickerId Unique identifier of the item
     * @returns {WithTickerItemRequestBuilder}
     */
     byTickerId(tickerId: Guid) : WithTickerItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvestmentAccountTickerGetResponse[]>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvestmentAccountTickerGetResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: InvestmentAccountTickerPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InvestmentAccountTickerPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TickersRequestBuilderUriTemplate = "{+baseurl}/investmentaccounts/{investmentAccountId}/tickers";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TickersRequestBuilderNavigationMetadata: Record<Exclude<keyof TickersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byTickerId: {
        requestsMetadata: WithTickerItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithTickerItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["tickerId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const TickersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TickersRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvestmentAccountTickerGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: TickersRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvestmentAccountTickerPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
